import { Box, Button} from '@mui/material'

const PricingSeasonsMessage = ({svgIcon, message, shoWMessage, okayButtonOnClick}) => {
    return (
        <Box className={`pricing-seasons-message ${shoWMessage ? 'show' : ''}`}>
            { shoWMessage ?
            <>
                {svgIcon}
                <div>{message}</div>
                <Button className="msg-btn" onClick={okayButtonOnClick} >Okay</Button>
            </> 
            : 
                null
            }
        </Box>
    )
}

export default PricingSeasonsMessage